/**
 * 管理后台登录态（与前台 user 隔离，存 sys_user 的 token）
 */
const ADMIN_TOKEN_KEY = 'AdminToken'
const ADMIN_NAME_KEY = 'AdminName'

export function getAdminToken() {
  return localStorage.getItem(ADMIN_TOKEN_KEY)
}

export function setAdminToken(token) {
  return localStorage.setItem(ADMIN_TOKEN_KEY, token)
}

export function removeAdminToken() {
  localStorage.removeItem(ADMIN_TOKEN_KEY)
  localStorage.removeItem(ADMIN_NAME_KEY)
}

export function setAdminName(name) {
  return localStorage.setItem(ADMIN_NAME_KEY, name)
}

export function getAdminName() {
  return localStorage.getItem(ADMIN_NAME_KEY)
}
